import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { SEARCH_VIDEO_BY_KEYWORD_API } from "../utils/contants";
import VideoCard, { AdVideoCard } from "./VideoCard";

const Results = () => {
  const [searchParams] = useSearchParams();
  const [searchResults, setSearchResults] = useState([]);
  const searchQuery = searchParams.get("search_query");

  const testingUrl = async () =>{
    const data = await fetch(SEARCH_VIDEO_BY_KEYWORD_API+ searchQuery);
    const json = await data.json();
    console.log(json.items);
    setSearchResults(json.items);
    };

  useEffect(()=>{
    testingUrl(); 
  },[searchQuery]);


  return (
     searchResults.length!==0 ?  
    <div className="md:w-screen md:mt-[8%] md:ml-[10%] w-[100%] flex flex-wrap">
      {searchResults[0] && <AdVideoCard info={searchResults[0]} />}
      {searchResults.map((video) => (
        <Link key={video.id.videoId} to={"/watch?v=" + video.id.videoId}>
          <VideoCard info={video} />
        </Link>
      ))}
    </div> : (<div className="md:w-screen md:mt-[8%] md:ml-[10%] w-[100%]">
        <p className="font-bold text-2xl">No results found</p>
        </div>)
  );
};

export default Results;
